import React, { useEffect, useState } from "react";

import { Card, CardBody, CardTitle, Spinner, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const StatsCard = ({ value="", label="" , icon ="", color= ""}) => {
  const getGradient = (baseColor) => {
    const gradients = {
      primary: "linear-gradient(135deg, #3a8ffe 0%, #1a6dff 100%)",
      success: "linear-gradient(135deg, #48d6a8 0%, #029666 100%)",
      info: "linear-gradient(135deg, #56CCF2 0%, #2D9CDB 100%)",
      warning: "linear-gradient(135deg, #FFB13D 0%, #FF9500 100%)",
      danger: "linear-gradient(135deg, #FF7285 0%, #FF3D57 100%)"
    };
    return gradients[baseColor] || gradients.primary;
  };

  return (
    <Card className="card-stats border border-gray-200 shadow-sm pb-3">
      <CardBody>
        <Row>
          <Col md="4" xs="5">
            <div className="icon-container mr-3 text-white rounded-circle p-3" 
            style={{  background: getGradient(color),
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"}}
              >
              <FontAwesomeIcon icon={icon} size="lg" />
            </div>
          </Col>
          <Col md="8" xs="7">
            <div className="numbers">
              <p className="card-category" style={{ fontSize: "0.9rem" }}>
               {label}
              </p>
              <CardTitle tag="p" className="mb-0">
                  <div style={{ color: "black", fontSize: "1.3rem" }}>
                    {value}
                  </div>
              </CardTitle>
              <p />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default StatsCard;
